// https://mui.com/material-ui/react-autocomplete/#country-select

import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import { countries, CountryType } from "constants/countries";

const CountryImageNode = ({ countryCode }: { countryCode: string }) => (
    <img
        loading="lazy"
        width="20"
        src={`https://flagcdn.com/w20/${countryCode.toLowerCase()}.png`}
        srcSet={`https://flagcdn.com/w40/${countryCode.toLowerCase()}.png 2x`}
        alt=""
    />
);

const PhoneNumberInput = (
    props: React.InputHTMLAttributes<HTMLInputElement>
) => {
    const [country, setCountry] = useState<CountryType | null>(
        countries.find((c) => c.code === "FR") || null
    );
    const [phoneNumber, setPhoneNumber] = useState("");

    return (
        <Grid container spacing={2} alignItems="center">
            <Grid item>
                <Autocomplete
                    options={countries}
                    value={country}
                    onChange={(event, newValue) => setCountry(newValue)}
                    autoHighlight
                    getOptionLabel={(option) => option.label}
                    renderOption={(props, option) => (
                        <Box
                            component="li"
                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                            {...props}
                        >
                            <CountryImageNode countryCode={option.code} />
                            {option.label} ({option.code}) +{option.phone}
                        </Box>
                    )}
                    renderInput={(params) => (
                        <TextField
                            required={props.required}
                            {...params}
                            inputProps={{
                                ...params.inputProps,
                                autoComplete: "new-password", // disable autocomplete and autofill
                            }}
                        />
                    )}
                    size="small"
                    sx={{ width: 180 }}
                />
            </Grid>

            <Grid item>
                {country ? (
                    <CountryImageNode countryCode={country!.code} />
                ) : (
                    <img width="20" alt="" />
                )}
            </Grid>

            <Grid item xs>
                <TextField
                    value={phoneNumber}
                    onChange={(event) => {
                        const newValue = event.target.value;

                        // Ensure new value is a number
                        // and not greater than 15 (max international phone number length)
                        if (
                            newValue !== "" &&
                            (newValue.length > 15 || !/^\d+$/.test(newValue))
                        )
                            return;

                        setPhoneNumber(newValue);
                    }}
                    required={props.required}
                    label="Phone number"
                    InputProps={{
                        startAdornment: country && (
                            <InputAdornment position="start">
                                <span>+{country?.phone} </span>
                            </InputAdornment>
                        ),
                    }}
                    fullWidth
                    inputProps={{
                        autoComplete: "new-password", // disable autocomplete and autofill
                    }}
                    size="small"
                />
            </Grid>

            <input
                {...props}
                type="hidden"
                value={`+${country?.phone}${phoneNumber}`}
            />
        </Grid>
    );
};

export default PhoneNumberInput;
